import FacebookLeadsApiSettingsTab from './facebook-leads-api-settings';

export default FacebookLeadsApiSettingsTab;
